import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesCarousel from './components/ServicesCarousel';
import ServicesGrid from './components/ServicesGrid';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-page">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesCarousel />
        <ServicesGrid />
        <WhyChooseUs />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
